import { PureComponent, ReactNode } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/socialFeed/FeedPost/FeedPostInfoBar.styl'

export type FeedPostInfoBarOwnProps = {
  children: ReactNode
  theme?: 'alert' | 'success' | 'action' | 'oxford'
}

class FeedPostInfoBar extends PureComponent<FeedPostInfoBarOwnProps> {
  render () {
    const { children, theme } = this.props

    const circleStyles = cn(styles.circle, {
      [styles.alert]: theme === 'alert',
      [styles.success]: theme === 'success',
      [styles.action]: theme === 'action',
    })

    return (
      <div className={ styles.bar }>
        <div className={ circleStyles } />
        <span>
          { children }
        </span>
      </div>
    )
  }
}

export default FeedPostInfoBar
